import React from 'react';
import { SettingsUsersManagementContent } from './components/SettingsUsersManagementContent';

export const SettingsUsersScreen = () => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="card stretch stretch-full card__no-border">
                    <div className="card-body pt-3">
                        <SettingsUsersManagementContent />
                    </div>
                </div>
            </div>
        </div>
    );
};
